import { render, staticRenderFns } from "./MissingDocuments.vue?vue&type=template&id=5ac26850&scoped=true"
import script from "./MissingDocuments.vue?vue&type=script&lang=js"
export * from "./MissingDocuments.vue?vue&type=script&lang=js"
import style0 from "./MissingDocuments.vue?vue&type=style&index=0&id=5ac26850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac26850",
  null
  
)

export default component.exports